<template>
    <common-page flex-column card-content @gotMenuName="nameLabel = $event">
        <dictionary-enum-edit :name-label="nameLabel" :code="getCode()" :with-label="withLabel"></dictionary-enum-edit>
    </common-page>
</template>

<script>
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import DictionaryEnumEdit from "@/views/common/dictionaryEnum/DictionaryEnumEdit.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";

export default {
    name: "DictionaryEnumEditPage",
    mixins: [emCommonUtilMixin],
    components: {DictionaryEnumEdit, CommonPage},
    props: {
        withLabel: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            nameLabel: null,
        }
    },
    methods: {
        getCode() {
            let code = this.$route.params.code;
            if (!this.hasCode(code)) {
                this.$message.warning("Error");
                return false;
            }
            return code;
        },
    }
}
</script>

<style scoped>

</style>
